import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-lg bg-blue-lp-600 px-2.5 py-1.5 flex items-center gap-y-1 flex-col"
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-x-2"
}
const _hoisted_3 = { class: "text-sm text-blue-lp-500" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Khusus informasi klaim Anda bisa melacak ")
const _hoisted_5 = { class: "flex items-center gap-x-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-blue-lp-500 text-left" }, " Hubungi CS untuk melaporkan kendala baru. ", -1)
const _hoisted_7 = { class: "text-sm text-blue-lp-500 text-left flex" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Telepon: ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "px-2.5" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "h-full bg-blue-lp-100",
    style: {"width":"2px"}
  })
], -1)
const _hoisted_11 = { class: "font-bold text-blue-lp-700 underline ml-5" }
const _hoisted_12 = {
  key: 1,
  class: "rounded-lg bg-blue-lp-600 px-2.5 py-1.5 flex flex-col gap-y-1"
}
const _hoisted_13 = {
  key: 0,
  class: "flex items-center gap-x-2"
}
const _hoisted_14 = { class: "text-sm text-blue-lp-500" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Khusus informasi klaim Anda bisa melacak ")
const _hoisted_16 = { class: "flex items-center gap-x-2" }
const _hoisted_17 = { class: "text-sm text-blue-lp-500 text-left flex" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Hubungi CS: ")
const _hoisted_19 = { class: "ml-1" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Telepon: ")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "px-2.5" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "h-full bg-blue-lp-100",
    style: {"width":"2px"}
  })
], -1)
const _hoisted_22 = { class: "font-bold text-blue-lp-700 underline ml-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.csInfoPopup)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.isClaim)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_Icons, {
                name: "info",
                class: "w-7 text-blue-lp-700"
              }),
              _createVNode("p", _hoisted_3, [
                _hoisted_4,
                _createVNode("a", {
                  href: `http://lionparcel.com/klaim/track?claim_id=${_ctx.sttNo}`,
                  class: "font-bold underline",
                  target: "_blank"
                }, " di sini. ", 8, ["href"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          (!_ctx.isClaim)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "info",
                class: "w-7 text-blue-lp-700"
              }))
            : _createCommentVNode("", true),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _hoisted_9,
            _createVNode("a", {
              class: "font-bold text-blue-lp-700 underline",
              href: `tel:${_ctx.formatCallPhoneNumber}`,
              target: "_blank"
            }, _toDisplayString(_ctx.callPhoneNumber), 9, ["href"])
          ]),
          _hoisted_10,
          _createVNode("span", {
            class: "inline-flex items-center text-green-lp-100 cursor-pointer relative",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickWhatsapp && _ctx.onClickWhatsapp(...args)))
          }, [
            _createVNode(_component_Icons, {
              name: "whatsapp",
              class: "w-4 absolute left-0 top-1/2 transform -translate-y-1/2"
            }),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.waPhoneNumber), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_12, [
        (_ctx.isClaim)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_Icons, {
                name: "info",
                class: "w-7 text-blue-lp-700"
              }),
              _createVNode("p", _hoisted_14, [
                _hoisted_15,
                _createVNode("a", {
                  href: `http://lionparcel.com/klaim/track?claim_id=${_ctx.sttNo}`,
                  class: "font-bold underline",
                  target: "_blank"
                }, " di sini. ", 8, ["href"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Icons, {
            name: "info",
            class: "w-7 text-blue-lp-700"
          }),
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("span", _hoisted_19, [
              _hoisted_20,
              _createVNode("a", {
                class: "font-bold text-blue-lp-700 underline",
                href: `tel:${_ctx.formatCallPhoneNumber}`,
                target: "_blank"
              }, _toDisplayString(_ctx.callPhoneNumber), 9, ["href"])
            ]),
            _hoisted_21,
            _createVNode("span", {
              class: "inline-flex items-center text-green-lp-100 cursor-pointer relative",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickWhatsapp && _ctx.onClickWhatsapp(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "whatsapp",
                class: "w-4 absolute left-0 top-1/2 transform -translate-y-1/2"
              }),
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.waPhoneNumber), 1)
            ])
          ])
        ])
      ]))
}